import { Icon } from "@/shared/ui";

export default function InventorySearchIcon() {
  return (
    <>
      <div
        className="absolute w-full left-1/2 -translate-x-1/2 flex justify-center z-2"
        style={{
          background: "radial-gradient(circle,rgba(33, 88, 231, 0.20) 0%, transparent 30%)",
        }}
      >
        <img src="./svg/inventory/searchCharacter.svg" alt="" className="w-[15.625rem] h-[16rem]" />
      </div>

      <div className="absolute w-full left-1/2 -translate-x-1/2 flex justify-center z-1">
        <Icon name="points" category="inventory" className="w-[20rem] h-[15rem] bg-white/10" />
      </div>
    </>
  );
}
